export type Platform =
  | 'facebook_feed'
  | 'instagram_feed'
  | 'instagram_story'
  | 'meta_ad'
  | 'google_display'
  | 'tiktok'
  | 'linkedin';

export type ExportFormat = 'static' | 'video' | 'pack';
export type AssetSize = 'square' | 'portrait' | 'story' | 'landscape';
export type DeliveryMethod = 'zip' | 'clipboard' | 'individual';

export interface AdvancedSettings {
  fileType: 'png' | 'jpg' | 'mp4';
  quality: 'standard' | 'high' | 'ultra';
  background: 'transparent' | 'solid' | 'original';
  animDuration: number;
  compression: boolean;
  safeZone: boolean;
  cropGuides: boolean;
}

export interface ExportState {
  selectedPlatforms: Platform[];
  exportFormat: ExportFormat;
  selectedSizes: AssetSize[];
  autoAdapt: boolean;
  includedContent: string[];
  deliveryMethod: DeliveryMethod;
  advanced: AdvancedSettings;
}

export interface ExportPreset {
  id: string;
  label: string;
  icon: string;
  platforms: Platform[];
  format: ExportFormat;
  sizes: AssetSize[];
  content: string[];
}

export const EXPORT_PRESETS: ExportPreset[] = [
  {
    id: 'meta_starter',
    label: 'Meta Starter Pack',
    icon: 'ri-facebook-circle-fill',
    platforms: ['facebook_feed', 'instagram_feed', 'meta_ad'],
    format: 'static',
    sizes: ['square', 'landscape'],
    content: ['image', 'headline', 'primary_text', 'cta'],
  },
  {
    id: 'social_bundle',
    label: 'Social Bundle',
    icon: 'ri-share-line',
    platforms: ['facebook_feed', 'instagram_feed', 'instagram_story', 'linkedin'],
    format: 'pack',
    sizes: ['square', 'portrait', 'story'],
    content: ['image', 'headline', 'primary_text', 'subheadline', 'cta', 'hashtags'],
  },
  {
    id: 'story_pack',
    label: 'Story Pack',
    icon: 'ri-phone-line',
    platforms: ['instagram_story', 'tiktok'],
    format: 'video',
    sizes: ['story'],
    content: ['image', 'video', 'headline', 'cta'],
  },
  {
    id: 'full_campaign',
    label: 'Full Campaign Kit',
    icon: 'ri-rocket-line',
    platforms: ['facebook_feed', 'instagram_feed', 'instagram_story', 'meta_ad', 'google_display', 'tiktok', 'linkedin'],
    format: 'pack',
    sizes: ['square', 'portrait', 'story', 'landscape'],
    content: ['image', 'video', 'headline', 'primary_text', 'subheadline', 'cta', 'caption', 'hashtags', 'brand'],
  },
];
